import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SidenavService } from "src/app/layout/sidenav/sidenav.service";
import { ApiService } from "src/app/services/api.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import endpoints from "src/app/helpers/endpoints";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { CommonService } from "src/app/services/common.service";
import { ErrorType } from "src/app/enums/error-type.enum";

@Component({
  selector: 'fury-view-customer-service-agreement',
  templateUrl: './view-customer-service-agreement.component.html',
  styleUrls: ['./view-customer-service-agreement.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ViewCustomerServiceAgreementComponent implements OnInit, OnDestroy {

  agreementNumber = "";
  agreementDetails: any;
  isLoading = false;
  ngUnsubscribe = new Subject<void>();

  constructor(
    private router: Router,
    private activateRoute: ActivatedRoute,
    private apiService: ApiService,
    public commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.agreementNumber = this.activateRoute.snapshot.params["agreementNumber"];
    if (this.agreementNumber) this.getAgreementDetails();
  }
  getAgreementDetails() {
    this.isLoading = true;
    this.apiService
      .get(endpoints.customerServiceAgreement.getAgreementDetails(this.agreementNumber))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
         this.isLoading = false;
          if (res.body) {
            this.agreementDetails = res.body?.agreement;
          }
        },
        error: (err: HttpErrorResponse)=>{
          this.apiService.alert(err.error?.message, ErrorType.Error);
          this.isLoading = false;
        }
      });
  }
  formatCurrency(priceValue) {
    if (!priceValue) return  "$0.00";
    return `$${Number(priceValue)?.toFixed(2)}`;
  }
  getWaitingPeriod(days) {
    if (!days) return "";
    if (Number(days) === 1) return `${days} day`;
    return `${days} days`;
  }
  redirectToAgreementList(){
    this.router.navigateByUrl("/customer-service-agreement/service-agreement-list")
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
